import { Eye, Pencil, Trash2 } from "lucide-react";
import { Button } from "../../../../components/ui/common/button";
import { ProductRowViewModel } from "../types/productListView.types";

interface ProductRowActionsProps {
  row: ProductRowViewModel;
  onView: (row: ProductRowViewModel) => void;
  onEdit: (row: ProductRowViewModel) => void;
  onDelete: (row: ProductRowViewModel) => void;
}

const actionButtonClass = "tw-h-8 tw-w-8";

/**
 * View / edit / delete icon actions for one grid row, built on the common
 * `Button` (ghost/icon variant) the same way `IngredientRowActions` does
 * (src/screens/lcaIngredients/ingredientList/components/IngredientRowActions.tsx).
 * Unlike the ingredient grid, every product row gets all three actions —
 * the legacy `ProductList` never gates these on anything (see
 * src/screens/product/productList/ProductList.tsx).
 */
const ProductRowActions = ({ row, onView, onEdit, onDelete }: ProductRowActionsProps) => {
  return (
    <div className="tw-flex tw-items-center tw-justify-end tw-gap-1">
      <Button
        variant="ghost"
        size="icon"
        className={actionButtonClass}
        title="View"
        onClick={() => onView(row)}
      >
        <Eye className="tw-h-3.5 tw-w-3.5" />
      </Button>
      <Button
        variant="ghost"
        size="icon"
        className={actionButtonClass}
        title="Edit"
        onClick={() => onEdit(row)}
      >
        <Pencil className="tw-h-3.5 tw-w-3.5" />
      </Button>
      <Button
        variant="ghost"
        size="icon"
        className={`${actionButtonClass} tw-text-destructive hover:tw-text-destructive`}
        title="Delete"
        onClick={() => onDelete(row)}
      >
        <Trash2 className="tw-h-3.5 tw-w-3.5" />
      </Button>
    </div>
  );
};

export default ProductRowActions;
